// src/components/AuthRedirect.tsx
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useSession } from "./SessionContext";

interface AuthRedirectProps {
    children: ReactNode;
    redirectTo?: string;
}

export default function AuthRedirect({ children, redirectTo = "/" }: AuthRedirectProps) {
    const { session } = useSession();

    if (session) {
        return <Navigate to={redirectTo} />;
    }

    return <>{children}</>;
}
